import React, { PropsWithChildren } from "react"
import { Image, ImageProps } from "@chakra-ui/image"
import { Box, Center, SimpleGrid } from "@chakra-ui/layout"

import Pattern from "~images/pages/home/hero/pattern.png"

import ResponsiveBlock from "~components/shared/layout/responsive-block"
import TestimonialBackground from "./background"
import TestimonialQuote from "./quote"

interface Props {
    headshot: string
    name: string
    location: string
    featured: string
    photoOverrides?: ImageProps
}

export default function TestimonialBanner({
    headshot,
    name,
    location,
    featured,
    photoOverrides,
    children,
}: PropsWithChildren<Props>) {
    return (
        <Box bg="brand.500" w="full" position="relative">
            <TestimonialBackground pattern={Pattern} />
            <ResponsiveBlock isWide position="relative">
                <SimpleGrid
                    w="full"
                    columns={{ base: 1, md: 2 }}
                    h="fit-content"
                >
                    <Center
                        display={{ base: "none", md: "flex" }}
                        p={12}
                        pr={24}
                    >
                        <Image
                            h="full"
                            w="full"
                            src={headshot}
                            objectFit="contain"
                            {...photoOverrides}
                        />
                    </Center>
                    <TestimonialQuote
                        featured={featured}
                        name={name}
                        location={location}
                    >
                        {children}
                    </TestimonialQuote>
                </SimpleGrid>
            </ResponsiveBlock>
        </Box>
    )
}
